export default __webpack_public_path__ + "static/media/servizi_richiesti.05d2e928.less";